import React from "react";
import { useSelector } from "react-redux";

import Layout from "../../../components/UI/Layout/Layout";
import ContasPagarList from "./ContasPagarList";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";

export var ScreensContasPagar = function() {
    var contasPagar = useSelector(function(state) {
        return state.contasPagar;
    });
    var isLoading = contasPagar && contasPagar.isLoading;

    return (
        <div>
            <LoadingTopBar isActive={isLoading} />
            <Layout>
                <ContasPagarList />
            </Layout>
        </div>
    );
};
